<div class="dp-wrapper bg-white border border-[#e8edf3] rounded-lg shadow-[0_12px_32px_rgba(40,56,66,0.22)] box-border flex flex-col w-[238px] max-w-[238px] min-w-[120px] text-center p-1.5">
	<div class="flex justify-between items-center content-center w-full mb-2">
		<div>
			<button (click)="changeMonth(-1)" class="dp-nav-btn flex items-center justify-center w-7 h-7 rounded-md text-corporate bg-transparent border-none cursor-pointer transition-all hover:bg-hover-2">
				<lucide-icon name="chevron-left" [size]="16"></lucide-icon>
			</button>
		</div>
		<h1 class="text-corporate-3 text-[13px] font-semibold m-0 capitalize">{{dateSelect | date:'MMMM, yyyy'}}</h1>
		<div>
			<button (click)="changeMonth(1)" class="dp-nav-btn flex items-center justify-center w-7 h-7 rounded-md text-corporate bg-transparent border-none cursor-pointer transition-all hover:bg-hover-2">
				<lucide-icon name="chevron-right" [size]="16"></lucide-icon>
			</button>
		</div>
	</div>
	<ol class="dp-grid list-none grid grid-cols-7 gap-0.5 m-0 p-0">
		<li *ngFor="let day of week" class="dp-weekday text-[11px] font-semibold text-corporate-3 opacity-60 text-center py-1 uppercase">{{day | slice:0:3}}</li>

        <li (click)="clickDay(day)" [style.gridColumnStart]="first ? day?.indexWeek : 'auto'"
         *ngFor="let day of monthSelect;let first = first" class="dp-day">
			 <span [ngClass]="{'daySelected': day.value == this.daySelected, 'dayNoSelected' : day.value !=this.daySelected}">{{day?.value}}</span>
		</li>
	</ol>
</div>